var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"GmXPanXmFmoCCFEf5uYgz"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["emak-frontend@webranking-srl"]={id:"GmXPanXmFmoCCFEf5uYgz"};
      